import { render, staticRenderFns } from "./PointsReturn.vue?vue&type=template&id=30af7ff2"
import script from "./PointsReturn.vue?vue&type=script&lang=js"
export * from "./PointsReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports